module.exports = __webpack_public_path__ + "static/media/ID.97ca943d.png";